<template>
    <form class="mb-0" ref="form" :data-url="`escorters/${escorterId}/card`"
        :class="{ 'loading-opacity': preloader }">
        <div class="profile-pic-wrapper position-relative text-center">
            <app-overlay-loader v-if="preloader" />
            <app-input v-else id="user_image" class="circle mx-xl-auto"
                :wrapper-class="'circle mx-xl-auto'" name="user_image" type="custom-file-upload"
                v-model="escorter.card" :generate-file-url="true" @change="setIdCard"
                :label="$t('id_card')" />
        </div>
    </form>            
</template>

<script>

import { mapState } from "vuex";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import * as actions from "../../../Config/ApiUrl";
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import { UserMixin } from "../Auth/Mixins/UserMixin";

export default {
    name: "EscorterDetails",
    mixins: [FormMixin, UserMixin],
    props: {
        escorterId: {},
    },
    computed: {
        ...mapState({
            escorter: state => state.escorter
        }),
    },
    data() {
        return {
            preloader: false,
            componentLoader: true,
        }
    },
    mounted() {
        if (!_.isEmpty(this.userInfo))
            this.componentLoader = false;
    },
    methods: {
        beforeSubmit() {
            this.preloader = true;
        },
        setIdCard($event) {
            const fileValue = $event.target.files[0];
            let formData = new FormData();
            formData.append('id_card', fileValue);
            this.save(formData);
        },
        afterFinalResponse() {
            this.preloader = false;
        },
        afterSuccess(res) {
            this.$toastr.s(res.data.message);
        },
    }
}
</script>
<style scoped>
.user-profile .card {
    min-height: 190px;
}
</style>
